import { render, staticRenderFns } from "./productInspection.vue?vue&type=template&id=aa05a016&scoped=true"
import script from "./productInspection.vue?vue&type=script&lang=js"
export * from "./productInspection.vue?vue&type=script&lang=js"
import style0 from "./productInspection.vue?vue&type=style&index=0&id=aa05a016&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa05a016",
  null
  
)

export default component.exports